/**
 * Textos de Compras (`es`): tall «devolucions» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `es.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const devolucionsEs = {
  // Lote devuelto, retorno inmediato y observaciones de la devolución (OBR-117, ficha QA del 19/10).
  'backoffice.returnedLots': {
    lotStatusReturned: 'Devuelto',
    immediateChip: 'Retorno inmediato',
    immediateCardNote:
      'El transportista se lo ha llevado en el momento: la entrada de la recepción y la salida de esta devolución se compensan, y esta cantidad no queda en las existencias.',
    immediateMovementNote:
      'Un retorno inmediato deja, en el mismo lote, la entrada de la recepción y la salida de la devolución: lo que vuelve no se queda en las existencias. Los movimientos no se editan; por eso ves los dos.',
    movementReturnNumber: 'Albarán de devolución {{number}}',
    createErrorObservationsTooLong: 'Las observaciones son demasiado largas (máximo {{max}} caracteres).',
    rejectObservationsLabel: 'Observaciones (opcional)',
    rejectObservationsHint: 'Se añaden a cada devolución que se crea, además del motivo.',
  },
} as const;
